var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "va-row" },
    [
      _c(
        "div",
        { staticClass: "flex md12 xs12" },
        [
          _c("vuestic-widget", [
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.app"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("basic.select.all"),
                        filterable: "",
                      },
                      model: {
                        value: _vm.waybillListParams.app_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.waybillListParams, "app_id", $$v)
                        },
                        expression: "waybillListParams.app_id",
                      },
                    },
                    _vm._l(_vm.appList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.waybillStatus"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("menu.wayBill") },
                      model: {
                        value: _vm.waybillListParams.review_status,
                        callback: function ($$v) {
                          _vm.$set(_vm.waybillListParams, "review_status", $$v)
                        },
                        expression: "waybillListParams.review_status",
                      },
                    },
                    _vm._l(_vm.waybillStatus, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "flex md4" }, [
                _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex md6" },
                    [
                      _c(
                        "div",
                        { staticClass: "select-title", staticStyle: {} },
                        [_vm._v(_vm._s(_vm._f("translate")("t.carrierRegion")))]
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "" },
                          on: { change: _vm.carrierRegionChange },
                          model: {
                            value: _vm.carrierRegion,
                            callback: function ($$v) {
                              _vm.carrierRegion = $$v
                            },
                            expression: "carrierRegion",
                          },
                        },
                        _vm._l(_vm.carriersRegion, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex md6" },
                    [
                      _c("div", { staticClass: "select-title" }, [
                        _vm._v(_vm._s(_vm._f("translate")("t.carrier"))),
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: _vm.$t("t.carrier"),
                          },
                          model: {
                            value: _vm.waybillListParams.carrier_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.waybillListParams,
                                "carrier_code",
                                $$v
                              )
                            },
                            expression: "waybillListParams.carrier_code",
                          },
                        },
                        _vm._l(_vm.filterCarriers, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.code, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.dateMode"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("t.dateMode") },
                      on: { change: _vm.dateModeChange },
                      model: {
                        value: _vm.waybillListParams.date_mode,
                        callback: function ($$v) {
                          _vm.$set(_vm.waybillListParams, "date_mode", $$v)
                        },
                        expression: "waybillListParams.date_mode",
                      },
                    },
                    _vm._l(_vm.dateModeOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.timeZone"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.isTimeZoned },
                      model: {
                        value: _vm.waybillListParams.zone_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.waybillListParams, "zone_id", $$v)
                        },
                        expression: "waybillListParams.zone_id",
                      },
                    },
                    _vm._l(_vm.timeZoneOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.dateRange"))),
                  ]),
                  _c("el-date-picker", {
                    staticStyle: { width: "100% !important" },
                    attrs: {
                      disabled: _vm.isTimeZoned,
                      type: "daterange",
                      "picker-options": _vm.pickerOptions,
                      "unlink-panels": "",
                      "range-separator": "-",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                      "start-placeholder": "start",
                      "end-placeholder": "end",
                    },
                    on: { focus: _vm.limitNextDay },
                    model: {
                      value: _vm.waybillListParams.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.waybillListParams, "time", $$v)
                      },
                      expression: "waybillListParams.time",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.trackingStatus"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("t.trackingStatus") },
                      model: {
                        value: _vm.waybillListParams.tracking_status,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.waybillListParams,
                            "tracking_status",
                            $$v
                          )
                        },
                        expression: "waybillListParams.tracking_status",
                      },
                    },
                    _vm._l(_vm.trackingStatus, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.searchMode"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("t.searchMode") },
                      model: {
                        value: _vm.waybillListParams.search_mode,
                        callback: function ($$v) {
                          _vm.$set(_vm.waybillListParams, "search_mode", $$v)
                        },
                        expression: "waybillListParams.search_mode",
                      },
                    },
                    _vm._l(_vm.searchModeOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("t.keyWords"))),
                  ]),
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: _vm.$t("t.keyWords") },
                    model: {
                      value: _vm.waybillListParams.search_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.waybillListParams, "search_key", $$v)
                      },
                      expression: "waybillListParams.search_key",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c("div", { staticClass: "flex mobile-btn mt-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-micro",
                    on: { click: _vm.searchWaybill },
                  },
                  [
                    _c("div", { staticClass: "btn-with-icon-content" }, [
                      _c("i", { staticClass: "ion-md-search ion" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm._f("translate")("basic.button.search")) +
                          "\n            "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "flex mobile-btn mt-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-micro",
                    on: { click: _vm.searchReset },
                  },
                  [
                    _c("div", { staticClass: "btn-with-icon-content" }, [
                      _c("i", { staticClass: "ion-md-refresh ion" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm._f("translate")("basic.button.reset")) +
                          "\n            "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex xs12 md12 w-table" },
        [
          _c("vuestic-widget", { attrs: { id: "dategridPayOrder" } }, [
            _c("div", { staticClass: "va-row" }, [
              _c("div", { staticClass: "flex md6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-micro",
                    on: { click: _vm.batchUpload },
                  },
                  [
                    _c("div", { staticClass: "btn-with-icon-content" }, [
                      _c("i", { staticClass: "ion-md-cloud-upload ion" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("translate")("basic.button.batchUpload")
                          ) +
                          "\n              "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "flex md6 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-micro mr-4",
                    on: { click: _vm.downloadLogs },
                  },
                  [
                    _c("div", { staticClass: "btn-with-icon-content" }, [
                      _c("i", { staticClass: "ion-md-download ion" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("translate")("basic.button.downloadLogs")
                          ) +
                          "\n              "
                      ),
                    ]),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-micro",
                    on: { click: _vm.download },
                  },
                  [
                    _c("div", { staticClass: "btn-with-icon-content" }, [
                      _c("i", { staticClass: "ion-md-download ion" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm._f("translate")("basic.button.download")) +
                          "\n              "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "table-responsive mt-2",
                attrs: { id: "waybillTable" },
              },
              [
                _c(
                  "table",
                  { staticClass: "table table-striped first-td-padding" },
                  [
                    _c("thead", [
                      _c(
                        "tr",
                        _vm._l(_vm.tableHeaderList, function (item, index) {
                          return _c("th", { key: index }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm._f("translate")(item.label)) +
                                "\n              "
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm.wayBillList
                      ? _c(
                          "tbody",
                          _vm._l(_vm.wayBillList, function (item, index) {
                            return _c("tr", { key: index }, [
                              _c("td", [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.fetchDetails(item.trade_no)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "alink",
                                        attrs: { href: "javascript:void(0);" },
                                      },
                                      [_vm._v(_vm._s(item.trade_no))]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(item.out_trade_no))]),
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.order_time) +
                                    "\n              "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.tracking_number) +
                                    "\n              "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.carrier_code) +
                                    "\n              "
                                ),
                              ]),
                              _c(
                                "td",
                                { attrs: { align: "right" } },
                                [
                                  item.tracking_status
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            "disable-transitions": "",
                                            type: _vm.getStatusColor(
                                              item.tracking_status
                                            ),
                                          },
                                        },
                                        [_vm._v(_vm._s(item.tracking_status))]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { attrs: { align: "right" } },
                                [
                                  _vm.reviewStatusText(item.review_status)
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            "disable-transitions": "",
                                            type: _vm.getStatusColor(
                                              item.review_status
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reviewStatusText(
                                                item.review_status
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.singleUpload(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          item.review_status == 1000 ||
                                            item.review_status == 1100
                                            ? _vm.$t("cards.link.edit")
                                            : _vm.$t("view")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          }),
                          0
                        )
                      : _c("tbody", [
                          _c("tr", [
                            _c("td", {
                              attrs: { colspan: "11" },
                              domProps: { textContent: _vm._s(_vm.noData) },
                            }),
                          ]),
                        ]),
                  ]
                ),
              ]
            ),
            _vm.isMobile === "pc"
              ? _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("pagination", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.total > 0,
                          expression: "total > 0",
                        },
                      ],
                      attrs: {
                        total: _vm.total,
                        "page-size": _vm.limit,
                        layout: "total, sizes, prev, pager, next, jumper",
                        background: "",
                        page: _vm.page,
                        limit: _vm.limit,
                      },
                      on: {
                        "update:page": function ($event) {
                          _vm.page = $event
                        },
                        "update:limit": function ($event) {
                          _vm.limit = $event
                        },
                        pagination: _vm.waybillData,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("pagination", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.total > 0,
                          expression: "total > 0",
                        },
                      ],
                      attrs: {
                        total: _vm.total,
                        layout: "total, prev, pager, next",
                        background: "",
                        page: _vm.page,
                        limit: _vm.limit,
                      },
                      on: {
                        "update:page": function ($event) {
                          _vm.page = $event
                        },
                        "update:limit": function ($event) {
                          _vm.limit = $event
                        },
                        pagination: _vm.waybillData,
                      },
                    }),
                  ],
                  1
                ),
          ]),
        ],
        1
      ),
      _c(
        "vuestic-modal",
        {
          ref: "uploadWayBill",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            show: _vm.uploadWayBillshow,
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
          },
          on: {
            "update:show": function ($event) {
              _vm.uploadWayBillshow = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.uploadWayBillTitle)),
          ]),
          _c("div", [
            _c("form", [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex xs12 md12" }, [
                  _c("fieldset", [
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("trade_no"),
                            valid: _vm.isFormFieldValid("trade_no"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.trade_no,
                                  expression: "uploadWayBill.trade_no",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "trade_no",
                                "data-vv-as": "Trade No",
                                autocomplete: "off",
                                required: "",
                                disabled: "",
                              },
                              domProps: { value: _vm.uploadWayBill.trade_no },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "trade_no",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "name" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("tables.detailsInfo.transactionID")
                                  )
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("trade_no"),
                                    expression: "errors.has('trade_no')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("trade_no")))]
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("merchantReference"),
                            valid: _vm.isFormFieldValid("merchantReference"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.merchantReference,
                                  expression: "uploadWayBill.merchantReference",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "merchantReference",
                                "data-vv-as": "Merchant Reference",
                                autocomplete: "off",
                                required: "",
                                disabled: "",
                              },
                              domProps: {
                                value: _vm.uploadWayBill.merchantReference,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "merchantReference",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "tables.listing.recurring_merchant_reference"
                                  )
                                )
                              ),
                            ]),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("merchantReference"),
                                    expression:
                                      "errors.has('merchantReference')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("merchantReference"))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      !_vm.isEdit
                        ? _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": _vm.initCarrierCountryVaild,
                                valid:
                                  _vm.isCarrierCountryVaild("carrierCountry"),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c("waybill-simple-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    ref: "carrierCountryInput",
                                    attrs: {
                                      name: "carrierCountry",
                                      "data-vv-as": "Carrier Region",
                                      required: "",
                                      label: _vm.$t("t.carrierRegion"),
                                      options: _vm.carriersRegion,
                                      "option-key": "value",
                                      autocomplete: "off",
                                      disabled: _vm.isEdit,
                                      clearable: "",
                                    },
                                    on: {
                                      input: _vm.carrierCountryForbiddenInput,
                                    },
                                    model: {
                                      value: _vm.uploadWayBill.carrierCountry,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.uploadWayBill,
                                          "carrierCountry",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "uploadWayBill.carrierCountry",
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass: "fa icon-right input-icon",
                                    on: { click: _vm.carrierClose },
                                  }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.initCarrierCountryVaild,
                                          expression: "initCarrierCountryVaild",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first("carrierCountry")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      !_vm.isEdit
                        ? _c("div", { staticClass: "info-group-space" })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.initCarrierVaild,
                            valid: _vm.isCarrierVaild("detailCarrier"),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c("waybill-simple-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                ref: "carrierInput",
                                attrs: {
                                  name: "detailCarrier",
                                  "data-vv-as": "Carrier",
                                  required: "",
                                  label: _vm.$t("t.carrier"),
                                  options: _vm.filterDetailCarriers,
                                  "option-key": "code",
                                  autocomplete: "off",
                                  disabled: _vm.isEdit,
                                  clearable: "",
                                },
                                on: { input: _vm.carrierForbiddenInput },
                                model: {
                                  value: _vm.uploadWayBill.detailCarrier,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.uploadWayBill,
                                      "detailCarrier",
                                      $$v
                                    )
                                  },
                                  expression: "uploadWayBill.detailCarrier",
                                },
                              }),
                              !_vm.isEdit
                                ? _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  })
                                : _vm._e(),
                              !_vm.isEdit
                                ? _c("i", {
                                    staticClass: "fa icon-right input-icon",
                                  })
                                : _vm._e(),
                              !_vm.isEdit
                                ? _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.initCarrierVaild,
                                          expression: "initCarrierVaild",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first("detailCarrier")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("trackingWebsite"),
                            valid: _vm.isFormFieldValid("trackingWebsite"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.trackingWebsite,
                                  expression: "uploadWayBill.trackingWebsite",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "trackingWebsite",
                                "data-vv-as": "Tracking Website",
                                autocomplete: "off",
                                required: "",
                                maxlength: "255",
                                disabled: _vm.isEdit,
                              },
                              domProps: {
                                value: _vm.uploadWayBill.trackingWebsite,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "trackingWebsite",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "trackingWebsite" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("waybill.trackingWebsite"))
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("trackingWebsite"),
                                    expression: "errors.has('trackingWebsite')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("trackingWebsite"))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("trackingNo"),
                            valid: _vm.isFormFieldValid("trackingNo"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.trackingNo,
                                  expression: "uploadWayBill.trackingNo",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "trackingNo",
                                "data-vv-as": "Tracking No",
                                autocomplete: "off",
                                required: "",
                                disabled: _vm.isEdit,
                              },
                              domProps: { value: _vm.uploadWayBill.trackingNo },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "trackingNo",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "trackingNo" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("tables.listing.trackingNo"))
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("trackingNo"),
                                    expression: "errors.has('trackingNo')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("trackingNo")))]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("notes"),
                            valid: _vm.isFormFieldValid("notes"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.notes,
                                  expression: "uploadWayBill.notes",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "notes",
                                "data-vv-as": "Notes",
                                autocomplete: "off",
                                required: "",
                                disabled: _vm.isEdit,
                              },
                              domProps: { value: _vm.uploadWayBill.notes },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "notes",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "notes" },
                              },
                              [_vm._v(_vm._s(_vm.$t("waybill.notes")))]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("notes"),
                                    expression: "errors.has('notes')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("notes")))]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm.isNotice
                      ? _c("div", { staticClass: "info-group info-disabled" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": _vm.errors.has("notice"),
                                valid: _vm.isFormFieldValid("notice"),
                              },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.uploadWayBill.notice,
                                      expression: "uploadWayBill.notice",
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: {
                                    name: "notice",
                                    "data-vv-as": `${_vm.VUE_APP_NAME} Notice`,
                                    autocomplete: "off",
                                    required: "",
                                    disabled: "",
                                  },
                                  domProps: { value: _vm.uploadWayBill.notice },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.uploadWayBill,
                                        "notice",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-check valid-icon icon-right input-icon",
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "notice" },
                                  },
                                  [_vm._v(_vm._s(_vm.VUE_APP_NAME) + " Notice")]
                                ),
                                _c("i", { staticClass: "bar" }),
                                _c(
                                  "small",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("notice"),
                                        expression: "errors.has('notice')",
                                      },
                                    ],
                                    staticClass: "help text-danger",
                                  },
                                  [_vm._v(_vm._s(_vm.errors.first("notice")))]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "vuestic-modal",
        {
          ref: "uploadWayBillView",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            show: _vm.uploadWayBillshow,
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
          },
          on: {
            "update:show": function ($event) {
              _vm.uploadWayBillshow = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.uploadWayBillTitle)),
          ]),
          _c("div", [
            _c("form", [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex xs12 md12" }, [
                  _c("fieldset", [
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("trade_no"),
                            valid: _vm.isFormFieldValid("trade_no"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.trade_no,
                                  expression: "uploadWayBill.trade_no",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "trade_no",
                                "data-vv-as": "Trade No",
                                autocomplete: "off",
                                required: "",
                                disabled: "",
                              },
                              domProps: { value: _vm.uploadWayBill.trade_no },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "trade_no",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "name" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("tables.detailsInfo.transactionID")
                                  )
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("trade_no"),
                                    expression: "errors.has('trade_no')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("trade_no")))]
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("merchantReference"),
                            valid: _vm.isFormFieldValid("merchantReference"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.merchantReference,
                                  expression: "uploadWayBill.merchantReference",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "merchantReference",
                                "data-vv-as": "Merchant Reference",
                                autocomplete: "off",
                                required: "",
                                disabled: "",
                              },
                              domProps: {
                                value: _vm.uploadWayBill.merchantReference,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "merchantReference",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "tables.listing.recurring_merchant_reference"
                                  )
                                )
                              ),
                            ]),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("merchantReference"),
                                    expression:
                                      "errors.has('merchantReference')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("merchantReference"))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.initCarrierVaild,
                            valid: _vm.isCarrierVaild("detailCarrier"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.detailCarrier.code,
                                  expression:
                                    "uploadWayBill.detailCarrier.code",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "detailCarrier",
                                "data-vv-as": "Carrier",
                                autocomplete: "off",
                                required: "",
                                maxlength: "255",
                                disabled: _vm.isEdit,
                              },
                              domProps: {
                                value: _vm.uploadWayBill.detailCarrier.code,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill.detailCarrier,
                                    "code",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v(_vm._s(_vm.$t("t.carrier"))),
                            ]),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("detailCarrier"),
                                    expression: "errors.has('detailCarrier')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("detailCarrier"))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("trackingWebsite"),
                            valid: _vm.isFormFieldValid("trackingWebsite"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.trackingWebsite,
                                  expression: "uploadWayBill.trackingWebsite",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "trackingWebsite",
                                "data-vv-as": "Tracking Website",
                                autocomplete: "off",
                                required: "",
                                maxlength: "255",
                                disabled: _vm.isEdit,
                              },
                              domProps: {
                                value: _vm.uploadWayBill.trackingWebsite,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "trackingWebsite",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "trackingWebsite" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("waybill.trackingWebsite"))
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("trackingWebsite"),
                                    expression: "errors.has('trackingWebsite')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("trackingWebsite"))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("trackingNo"),
                            valid: _vm.isFormFieldValid("trackingNo"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.trackingNo,
                                  expression: "uploadWayBill.trackingNo",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "trackingNo",
                                "data-vv-as": "Tracking No",
                                autocomplete: "off",
                                required: "",
                                disabled: _vm.isEdit,
                              },
                              domProps: { value: _vm.uploadWayBill.trackingNo },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "trackingNo",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "trackingNo" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("tables.listing.trackingNo"))
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("trackingNo"),
                                    expression: "errors.has('trackingNo')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("trackingNo")))]
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("tracking_status"),
                            valid: _vm.isFormFieldValid("tracking_status"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentItem.tracking_status,
                                  expression: "currentItem.tracking_status",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "tracking_status",
                                "data-vv-as": "Tracking No",
                                autocomplete: "off",
                                required: "",
                                disabled: _vm.isEdit,
                              },
                              domProps: {
                                value: _vm.currentItem.tracking_status,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.currentItem,
                                    "tracking_status",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "tracking_status" },
                              },
                              [_vm._v(_vm._s(_vm.$t("t.trackingStatus")))]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("tracking_status"),
                                    expression: "errors.has('tracking_status')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("tracking_status"))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("tracking_submit_time"),
                            valid: _vm.isFormFieldValid("tracking_submit_time"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentItem.tracking_submit_time,
                                  expression:
                                    "currentItem.tracking_submit_time",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "tracking_submit_time",
                                "data-vv-as": "Tracking Submit Time",
                                autocomplete: "off",
                                required: "",
                                disabled: _vm.isEdit,
                              },
                              domProps: {
                                value: _vm.currentItem.tracking_submit_time,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.currentItem,
                                    "tracking_submit_time",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "tracking_submit_time" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("waybill.trackingSubmitTime"))
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "tracking_submit_time"
                                    ),
                                    expression:
                                      "errors.has('tracking_submit_time')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first("tracking_submit_time")
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("notes"),
                            valid: _vm.isFormFieldValid("notes"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadWayBill.notes,
                                  expression: "uploadWayBill.notes",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: "notes",
                                "data-vv-as": "Notes",
                                autocomplete: "off",
                                required: "",
                                disabled: _vm.isEdit,
                              },
                              domProps: { value: _vm.uploadWayBill.notes },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.uploadWayBill,
                                    "notes",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "notes" },
                              },
                              [_vm._v(_vm._s(_vm.$t("waybill.notes")))]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("notes"),
                                    expression: "errors.has('notes')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("notes")))]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group info-disabled" }, [
                      _c("div", { staticClass: "form-group with-icon-right" }, [
                        _c("div", { staticClass: "input-group" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fromDetail,
                                expression: "fromDetail",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              name: "tracking_submit_time",
                              autocomplete: "off",
                              required: "",
                              disabled: _vm.isEdit,
                              rows: "4",
                            },
                            domProps: { value: _vm.fromDetail },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.fromDetail = $event.target.value
                              },
                            },
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "tracking_submit_time" },
                            },
                            [_vm._v("Tracking Info (From)")]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("tracking_submit_time"),
                                  expression:
                                    "errors.has('tracking_submit_time')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("tracking_submit_time"))
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "info-group-space" }),
                      _c("div", { staticClass: "form-group with-icon-right" }, [
                        _c("div", { staticClass: "input-group" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.toDetail,
                                expression: "toDetail",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              name: "notes",
                              autocomplete: "off",
                              required: "",
                              disabled: _vm.isEdit,
                              rows: "4",
                            },
                            domProps: { value: _vm.toDetail },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.toDetail = $event.target.value
                              },
                            },
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "tracking_submit_time" },
                            },
                            [_vm._v("Tracking Info (To)")]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("tracking_submit_time"),
                                  expression:
                                    "errors.has('tracking_submit_time')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("tracking_submit_time"))
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "padding-top": "3vh" },
          attrs: {
            title: _vm.$t("menu.paymentOrderDetails2"),
            id: "paymentDetails",
            visible: _vm.dialogTableVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            close: _vm.initRefund,
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex xs12 md12 w-table" },
                [
                  _c(
                    "vuestic-widget",
                    { attrs: { headerText: _vm.$t("tables.details") } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-responsive",
                          attrs: { id: "details" },
                        },
                        [
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm._f("translate")(
                                          "tables.detailsInfo.transactionID"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.amount"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.prodDesc"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.method"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.Status"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.createDate"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.detailInfo, function (val, index) {
                                return _c(
                                  "tr",
                                  { key: index },
                                  _vm._l(val, function (item, i) {
                                    return _c(
                                      "td",
                                      { key: i, style: _vm.centerText },
                                      [
                                        _vm.detailMethod && item === "Refund"
                                          ? _c("span", [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-danger btn-micro",
                                                  class: {
                                                    disable: !_vm.refundCanDo,
                                                  },
                                                  attrs: {
                                                    disabled: !_vm.refundCanDo,
                                                  },
                                                  on: {
                                                    click: _vm.showMediumModal,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(item) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : item === "Callback"
                                          ? _c("span", [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-info btn-micro",
                                                  attrs: {
                                                    disabled: _vm.isLoading,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.callbackOrderStatus,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.isLoading
                                                          ? ""
                                                          : "callback"
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                  _vm.isLoading
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("loading")
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ])
                                          : item === "Match Status"
                                          ? _c("span", [
                                              _vm.locationHost ===
                                              `dashboard-test.${_vm.envName}.com`
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-info btn-micro",
                                                      on: {
                                                        click:
                                                          _vm.showModalFillOrder,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(item) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(item) +
                                                  "\n                      "
                                              ),
                                            ]),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "block" }),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex xs12 md12" },
                [
                  _c(
                    "vuestic-widget",
                    { attrs: { headerText: _vm.$t("tables.statusHis") } },
                    [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-striped first-td-padding",
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.statusHisInfo.status"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.statusHisInfo.date"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.statusHisInfo.amount"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.cbStatus"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.statusHistoryInfo,
                                function (item, idx) {
                                  return _c(
                                    "tr",
                                    { key: idx },
                                    _vm._l(item, function (sli, b) {
                                      return _c(
                                        "td",
                                        { key: b, style: _vm.centerText },
                                        [_c("span", [_vm._v(_vm._s(sli))])]
                                      )
                                    }),
                                    0
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex xs12 md6" },
                [
                  _c(
                    "vuestic-widget",
                    { attrs: { headerText: _vm.$t("tables.buyer") } },
                    [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-striped first-td-padding",
                          },
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.buyerInfo, function (bitem, bindex) {
                                return _c(
                                  "tr",
                                  {
                                    key: bindex,
                                    staticStyle: { "text-align": "left" },
                                  },
                                  _vm._l(bitem, function (bval, bid) {
                                    return _vm.hideBuyerTd(bid)
                                      ? _c(
                                          "td",
                                          { key: bid, style: _vm.sizeLeft },
                                          [
                                            _c("span", {
                                              class: _vm.spanWrapper,
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getVerticalTabTd(
                                                    bval,
                                                    bid,
                                                    "buyer",
                                                    Object.keys(bitem).indexOf(
                                                      bid
                                                    ),
                                                    bindex
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex xs12 md6" },
                [
                  _c(
                    "vuestic-widget",
                    { attrs: { headerText: _vm.$t("tables.merchant") } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-responsive",
                          attrs: { id: "merchant" },
                        },
                        [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped first-td-padding",
                            },
                            [
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.merchantInfo,
                                  function (mitem, mkey) {
                                    return _c(
                                      "tr",
                                      {
                                        key: mkey,
                                        staticStyle: { "text-align": "left" },
                                      },
                                      [
                                        _c("td", { style: _vm.sizeLeft }, [
                                          _c("span", {
                                            class: _vm.spanWrapper,
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getVerticalTabTd(
                                                  mkey,
                                                  mitem,
                                                  "merchant"
                                                )
                                              ),
                                            },
                                          }),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm.transactionInfo.length > 0
              ? _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex xs12 md6" },
                    [
                      _c(
                        "vuestic-widget",
                        {
                          attrs: {
                            headerText: _vm.$t("tables.transactionCost"),
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "table-responsive",
                              attrs: { id: "transCoat" },
                            },
                            [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-striped first-td-padding",
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "tables.transactionDetails.option"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                      _c("th", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "tables.transactionDetails.setting"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("translate")(
                                              "tables.transactionDetails.fee"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.transactionInfo,
                                      function (titem, idx) {
                                        return _c(
                                          "tr",
                                          { key: idx },
                                          _vm._l(titem, function (list, t) {
                                            return _c("td", { key: t }, [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(list),
                                                },
                                              }),
                                            ])
                                          }),
                                          0
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.depositUpload.uploadUrl
              ? _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex xs12 md6" },
                    [
                      _c(
                        "vuestic-widget",
                        { attrs: { headerText: _vm.$t("tables.voucher") } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "deposit-upload",
                              attrs: { id: "depositUpload" },
                            },
                            [
                              _c(
                                "ul",
                                { staticStyle: { width: "70%" } },
                                _vm._l(_vm.payVouchers, function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass: "oneline-voucher",
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "key col-md-5",
                                        domProps: {
                                          textContent: _vm._s(item.name),
                                        },
                                      }),
                                      _c("span", {
                                        staticClass: "key col-md-5",
                                        domProps: {
                                          textContent: _vm._s(item.time),
                                        },
                                      }),
                                      item.url
                                        ? _c("a", {
                                            staticClass:
                                              "iconicstroke iconicstroke-download",
                                            staticStyle: {
                                              "font-size": "24px",
                                              cursor: "pointer",
                                            },
                                            attrs: { href: item.url },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downloadAttachment(
                                                  item,
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-primary btn-micro pull-right",
                                  attrs: {
                                    href: _vm.depositUpload.uploadUrl,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("basic.button.upload")))]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.refusedFg
              ? _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex xs12 md6" },
                    [
                      _c(
                        "vuestic-widget",
                        { attrs: { headerText: _vm.$t("tables.antiFraud") } },
                        [
                          _c("div", { staticClass: "refused-info" }, [
                            _c("ul", { staticStyle: { width: "70%" } }, [
                              _c("li", { staticClass: "oneline-voucher" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.refusedInfo"))),
                                ]),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(_vm.refusedInfo),
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "modals-page", attrs: { id: "refundReason" } },
            [
              _c(
                "vuestic-modal",
                {
                  ref: "mediumModal",
                  staticStyle: { height: "100%", width: "60vw" },
                  attrs: {
                    show: _vm.show,
                    okText: _vm._f("translate")("modal.confirm2"),
                    okClass: "btn btn-primary btn-micro",
                    cancelClass: "btn btn-secondary btn-micro",
                    cancelText: _vm._f("translate")("modal.cancel2"),
                  },
                  on: {
                    "update:show": function ($event) {
                      _vm.show = $event
                    },
                    cancel: _vm.handleModalClose,
                  },
                },
                [
                  _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("modal.refundReason"))),
                  ]),
                  _c("div", [
                    _c("form", [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md12" }, [
                          _c(
                            "fieldset",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error": _vm.errors.has("refundAmount"),
                                    valid: _vm.isFormFieldValid("refundAmount"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.refundAmount,
                                          expression: "refundAmount",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      attrs: {
                                        id: "simple-input",
                                        name: "refundAmount",
                                        "data-vv-as": "Name",
                                        autocomplete: "off",
                                        required: "",
                                      },
                                      domProps: { value: _vm.refundAmount },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.refundAmount = $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "simple-input" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("translate")(
                                              "forms.inputs.refundAmount"
                                            )
                                          ) + "："
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.errors.has("refundAmount"),
                                            expression:
                                              "errors.has('refundAmount')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.errors.first("refundAmount")
                                            ) +
                                            "\n                      "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error":
                                      _vm.errors.has("successfulEmail"),
                                    valid: _vm.isSuccessfulEmailValid,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.successfulEmail,
                                          expression: "successfulEmail",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|email",
                                          expression: "'required|email'",
                                        },
                                      ],
                                      attrs: {
                                        id: "successfulEmail",
                                        name: "successfulEmail",
                                        autocomplete: "off",
                                        required: "",
                                      },
                                      domProps: { value: _vm.successfulEmail },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.successfulEmail =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "successfulEmail" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "forms.inputs.buyerEmail"
                                              )
                                            ) +
                                            "：\n                      "
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.errors.has("successfulEmail"),
                                            expression:
                                              "errors.has('successfulEmail')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "successfulEmail"
                                              )
                                            ) +
                                            "\n                      "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error":
                                      _vm.errors.has("refundExplain"),
                                    valid:
                                      _vm.isFormFieldValid("refundExplain"),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex md12 xs12",
                                      attrs: { id: "textareawrapper" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.refundExplain,
                                                expression: "refundExplain",
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'",
                                              },
                                            ],
                                            style: _vm.paddTop,
                                            attrs: {
                                              type: "text",
                                              name: "refundExplain",
                                              "data-vv-as": "Name",
                                              id: "simple-textarea",
                                              placeholder: _vm.$t(
                                                "payment.upTo100Characters"
                                              ),
                                              maxlength: "100",
                                              rows: "2",
                                              required: "",
                                            },
                                            domProps: {
                                              value: _vm.refundExplain,
                                            },
                                            on: {
                                              focus: _vm.resizeLabel,
                                              blur: _vm.focusLabel,
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.refundExplain =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "simple-textarea" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "forms.inputs.description"
                                                  )
                                                ) + "："
                                              ),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has(
                                                      "refundExplain"
                                                    ),
                                                  expression:
                                                    "errors.has('refundExplain')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "refundExplain"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.speiFlag
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error": _vm.errors.has("bank"),
                                        valid: _vm.isFormFieldValid("bank"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "bank",
                                                name: "bank",
                                                filterable: true,
                                                required: "",
                                                placeholder: _vm.$t(
                                                  "payment.pleaseSelectABank"
                                                ),
                                              },
                                              on: {
                                                change: _vm.selectBankCode,
                                              },
                                              model: {
                                                value: _vm.bankCode,
                                                callback: function ($$v) {
                                                  _vm.bankCode = $$v
                                                },
                                                expression: "bankCode",
                                              },
                                            },
                                            _vm._l(
                                              _vm.bankCodeList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has("bank"),
                                                  expression:
                                                    "errors.has('bank')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first("bank")
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.speiFlag
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error": _vm.errors.has("clabe"),
                                        valid: _vm.isFormFieldValid("clabe"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.clabe,
                                                expression: "clabe",
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'",
                                              },
                                            ],
                                            attrs: {
                                              id: "clabe",
                                              name: "clabe",
                                              autocomplete: "off",
                                              required: "",
                                            },
                                            domProps: { value: _vm.clabe },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.clabe = $event.target.value
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "clabe" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        CLABE：\n                      "
                                              ),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has("clabe"),
                                                  expression:
                                                    "errors.has('clabe')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first("clabe")
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.checkCanRefund() && !_vm.speiFlag
                                ? _c("vuestic-checkbox", {
                                    ref: "other",
                                    attrs: {
                                      label: _vm.$t("forms.controls.options"),
                                    },
                                    model: {
                                      value: _vm.checkboxOption,
                                      callback: function ($$v) {
                                        _vm.checkboxOption = $$v
                                      },
                                      expression: "checkboxOption",
                                    },
                                  })
                                : _vm._e(),
                              _vm.dispalyOtherFg
                                ? _c("div", { attrs: { id: "user_info" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error":
                                            _vm.errors.has("username"),
                                          valid:
                                            _vm.isFormFieldValid("username"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.username,
                                                  expression: "username",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "uname-input",
                                                name: "username",
                                                "data-vv-as": "Name",
                                                required: "",
                                              },
                                              domProps: { value: _vm.username },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.username =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "uname-input" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.username"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has(
                                                        "username"
                                                      ),
                                                    expression:
                                                      "errors.has('username')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "username"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.errors.has("cpfNO"),
                                          valid: _vm.isFormFieldValid("cpfNO"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.cpfNO,
                                                  expression: "cpfNO",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "cpfNO-input",
                                                name: "cpfNO",
                                                "data-vv-as": "Name",
                                                maxlength: "14",
                                                required: "",
                                              },
                                              domProps: { value: _vm.cpfNO },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.cpfNO =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "cpfNO-input" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.cpfNO"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has("cpfNO"),
                                                    expression:
                                                      "errors.has('cpfNO')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first("cpfNO")
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.errors.has("agency"),
                                          valid: _vm.isFormFieldValid("agency"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.agency,
                                                  expression: "agency",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "agency-input",
                                                name: "agency",
                                                "data-vv-as": "Name",
                                                maxlength: "6",
                                                onkeyup:
                                                  "this.value=this.value.replace(/[^a-zA-Z0-9\\-]/g,'')",
                                                ondragenter: "return false",
                                                ondragover: "return false",
                                                required: "",
                                              },
                                              domProps: { value: _vm.agency },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.agency =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "agency-input" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.agency"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has("agency"),
                                                    expression:
                                                      "errors.has('agency')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first("agency")
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.initSelectedVaild,
                                          valid: _vm.isBankVaild(_vm.selBank),
                                        },
                                        attrs: { id: "bankWrapper" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("vuestic-simple-select", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              ref: "bankInput",
                                              attrs: {
                                                label:
                                                  _vm.$t("forms.inputs.bank"),
                                                name: "selBank",
                                                "data-vv-as": "Name",
                                                autocomplete: "off",
                                                required: "",
                                                "option-key": "description",
                                                options: _vm.bankOptions,
                                              },
                                              on: { input: _vm.forbiddenInput },
                                              model: {
                                                value: _vm.selBank,
                                                callback: function ($$v) {
                                                  _vm.selBank = $$v
                                                },
                                                expression: "selBank",
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.initSelectedVaild,
                                                    expression:
                                                      "initSelectedVaild",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                                staticStyle: {
                                                  display: "block",
                                                  "margin-top": "-30px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "selBank"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error":
                                            _vm.initSelAccoutTypeVaild,
                                          valid: _vm.isAccountVaild(
                                            _vm.accountType
                                          ),
                                        },
                                        attrs: { id: "accountWrapper" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("vuestic-simple-select", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              ref: "accountInput",
                                              attrs: {
                                                label: _vm.$t(
                                                  "forms.inputs.accountType"
                                                ),
                                                name: "accountType",
                                                "data-vv-as": "Name",
                                                autocomplete: "off",
                                                required: "",
                                                "option-key": "description",
                                                options: _vm.accountOptions,
                                              },
                                              on: {
                                                input:
                                                  _vm.forbiddenAccountInput,
                                              },
                                              model: {
                                                value: _vm.accountType,
                                                callback: function ($$v) {
                                                  _vm.accountType = $$v
                                                },
                                                expression: "accountType",
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.initSelAccoutTypeVaild,
                                                    expression:
                                                      "initSelAccoutTypeVaild",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                                staticStyle: {
                                                  display: "block",
                                                  "margin-top": "-30px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "accountType"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.bankAccountNumberFirst,
                                                  expression:
                                                    "bankAccountNumberFirst",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              staticStyle: {
                                                display: "inline-block",
                                                width: "60%",
                                              },
                                              attrs: {
                                                id: "card_number",
                                                name: "card_number",
                                                "data-vv-as": "Name",
                                                onpaste: "return false",
                                                ondragenter: "return false",
                                                ondragover: "return false",
                                                maxlength: "14",
                                                required: "",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.bankAccountNumberFirst,
                                              },
                                              on: {
                                                focus: function ($event) {
                                                  return _vm.formatCardNumber(
                                                    $event
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.bankAccountNumberFirst =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("—")]),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.bankAccountNumberLast,
                                                  expression:
                                                    "bankAccountNumberLast",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              staticStyle: {
                                                display: "inline-block",
                                                width: "20%",
                                                "padding-left": "10px",
                                              },
                                              attrs: {
                                                id: "branch_num",
                                                name: "branch_num",
                                                "data-vv-as": "Name",
                                                maxlength: "2",
                                                onkeyup:
                                                  "this.value=this.value.replace(/\\D/g,'')",
                                                onkeydown:
                                                  "this.value=this.value.replace(/\\D/g,'')",
                                                onpaste: "return false",
                                                ondragenter: "return false",
                                                ondragover: "return false",
                                                required: "",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.bankAccountNumberLast,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.bankAccountNumberLast =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "card_number" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.bankAccountNumber"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error": _vm.errors.has("userPass"),
                                    valid: _vm.isFormFieldValid("userPass"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.userPass,
                                          expression: "userPass",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      attrs: {
                                        name: "userPass",
                                        "data-vv-as": "Password",
                                        type: "password",
                                        id: "password",
                                        required: "required",
                                        onkeyup:
                                          "value=value.replace(/\\s/g,'')",
                                        onkeydown:
                                          "value=value.replace(/\\s/g,'')",
                                      },
                                      domProps: { value: _vm.userPass },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.userPass = $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "password" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("auth.password")) +
                                            "：\n                      "
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has("userPass"),
                                            expression:
                                              "errors.has('userPass')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("userPass"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "modals-page", attrs: { id: "fillOrder" } },
            [
              _c(
                "vuestic-modal",
                {
                  ref: "fillOrderModal",
                  staticStyle: { height: "100%", width: "60vw" },
                  attrs: {
                    show: _vm.show,
                    okText: _vm._f("translate")("modal.confirm2"),
                    okClass: "btn btn-primary btn-micro",
                    cancelClass: "btn btn-secondary btn-micro",
                    cancelText: _vm._f("translate")("modal.cancel2"),
                  },
                  on: {
                    "update:show": function ($event) {
                      _vm.show = $event
                    },
                    cancel: _vm.fillOrderModalClose,
                  },
                },
                [
                  _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("modal.fillOrder"))),
                  ]),
                  _c("div", [
                    _c("form", [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md12" }, [
                          _c("fieldset", [
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("orderStatus"),
                                  valid: _vm.isFormFieldValid("orderStatus"),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'",
                                          },
                                        ],
                                        attrs: {
                                          id: "orderStatus",
                                          name: "orderStatus",
                                          "data-vv-as": "status",
                                          filterable: true,
                                          required: "",
                                          placeholder:
                                            _vm.$t("pleaseSelectStatus"),
                                        },
                                        on: { change: _vm.selectStatusCode },
                                        model: {
                                          value: _vm.fillStatus,
                                          callback: function ($$v) {
                                            _vm.fillStatus = $$v
                                          },
                                          expression: "fillStatus",
                                        },
                                      },
                                      _vm._l(
                                        _vm.statusOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.errors.has("orderStatus"),
                                            expression:
                                              "errors.has('orderStatus')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.errors.first("orderStatus")
                                            ) +
                                            "\n                      "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("userPass"),
                                  valid: _vm.isFormFieldValid("userPass"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userPass,
                                        expression: "userPass",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      name: "userPass",
                                      "data-vv-as": "Password",
                                      type: "password",
                                      id: "password",
                                      required: "required",
                                      onkeyup: "value=value.replace(/\\s/g,'')",
                                      onkeydown:
                                        "value=value.replace(/\\s/g,'')",
                                    },
                                    domProps: { value: _vm.userPass },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.userPass = $event.target.value
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "password" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.$t("auth.password")) +
                                          "：\n                      "
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("userPass"),
                                          expression: "errors.has('userPass')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("userPass"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm.isToastContentPresent
            ? _c("div", { staticClass: "flex xs12 md6 flex-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "toasted-container sample-toasted-container shrink",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "toasted vuestic-toast none default" },
                      [
                        _vm.toastIcon
                          ? _c("i", { staticClass: "fa", class: _vm.toastIcon })
                          : _vm._e(),
                        _vm._v(
                          "\n          " + _vm._s(_vm.toastText) + "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }